import React from 'react';
export const DzUserConfigContext = React.createContext({
    partner: {},
    user: {},
    userDetails: {},
});
